import React, { useEffect, useState } from 'react';
import { whatsappInboxAPI } from '../../services/api';

// Unread-conversation count next to the WhatsApp Inbox sidebar item, so a staff member working
// elsewhere in the CRM still notices a customer has written in. Rendered inside the shared
// admin layout, so it fails silently and renders nothing at all rather than risking the nav:
// a gateway hiccup or a missing permission must never break navigation.
const POLL_MS = 30000;

export default function InboxUnreadBadge() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      whatsappInboxAPI.getUnreadCount()
        .then((res) => { if (!cancelled) setCount(res.data?.count || 0); })
        .catch(() => { if (!cancelled) setCount(0); });
    };
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, POLL_MS);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!count) return null;
  return (
    <span style={{
      marginLeft: 'auto', background: 'var(--cb-0ca30c)', color: 'var(--c-ffffff)', borderRadius: 10,
      fontSize: 11, padding: '1px 7px', fontWeight: 600, lineHeight: '16px',
    }}>
      {count > 99 ? '99+' : count}
    </span>
  );
}
